module.exports = __webpack_public_path__ + "img/audio_title.011dcacc.png";